import { Component } from '@angular/core'
import { BaseCellComponent } from './base-cell.component'

interface TransformProps<D> { transform: <F extends keyof D>(input: D[F]) => string; }
interface TransformDataProps<D> { transformData: (input: D) => string; }
type TransformCellComponentProps<D> = Readonly<TransformProps<D> | TransformDataProps<D>>

const isTransformProps = <D>(p: TransformCellComponentProps<D>): p is TransformProps<D> => 
  Object.prototype.hasOwnProperty.call(p, 'transform') 

@Component({
  selector: 'transform-cell',
  styles: `
        :host {
            position: relative;
        }
    `,
  template: `
    {{ val }}
  `,
})
export class TransformCellComponent<
  DATA = Record<string, unknown>,
> extends BaseCellComponent<
    DATA,
    TransformCellComponentProps<DATA>,
    keyof DATA
  > { 

  get val() {
    return isTransformProps(this.params) 
      ? this.params.value ? this.params.transform(this.params.value) : '-'
      : this.params.data ? this.params.transformData(this.params.data) : '-'
  }
}
